import { Box, DataList, VStack, Flex, Table, CloseButton, Dialog, Portal } from '@chakra-ui/react';
import { Link } from 'toolkit/chakra/link';
import { LuAlignJustify } from 'react-icons/lu';
import React, { useState, useEffect, useRef } from 'react';
import useApiQuery, { getResourceKey } from 'lib/api/useApiQuery';
import { route } from 'nextjs-routes';
import { BLOCK } from 'stubs/block';
import { Heading } from 'toolkit/chakra/heading';
import { Fragment } from 'types/views/fragment';

interface NextBlockFragsProps {
    fragData: Fragment | null;
    connectionStatus: 'connecting' | 'connected' | 'disconnected';
    formatTimestamp: (timestamp: number) => string;
}

const NextBlockFrags = ({ fragData, connectionStatus, formatTimestamp }: NextBlockFragsProps) => {

    const items = fragData ? [
        { label: "Number of transactions", value: fragData.data.nTxs },
        { label: "Gas", value: fragData.data.gasUsed.toLocaleString() },
    ] : [];

    return (
        <>
            <Box width={{ base: '100%', lg: '280px' }} mb={4} flexShrink={0}>
                <Heading level="3" mb={3}>
                    Frags in block
                    &nbsp;<span style={{ fontSize: 20 }}>
                        {fragData?.blockNumber ? fragData.blockNumber : '...'}
                    </span>
                </Heading>

                <Box mt={3}>
                    <VStack gap={2} mb={3} overflow="hidden" alignItems="stretch">
                        {fragData ? (
                            <Box
                                borderRadius="md"
                                border="1px solid"
                                borderColor="border.divider"
                                p={3}
                            >
                                <Flex alignItems="center" justify="space-between" overflow="hidden" w="100%" mb={3}>
                                    <Flex alignItems="center" gap={2}>
                                        <LuAlignJustify />
                                        <span style={{ fontSize: 20 }}>{fragData.data.seq}</span>
                                    </Flex>
                                    <span style={{ color: "#718096", fontSize: 14 }}>
                                        {formatTimestamp(fragData.timestamp)}
                                    </span>
                                </Flex>
                                <DataList.Root orientation="horizontal">
                                    {items.map((item) => (
                                        <DataList.Item key={item.label}>
                                            <DataList.ItemLabel>{item.label}</DataList.ItemLabel>
                                            <DataList.ItemValue>{item.value}</DataList.ItemValue>
                                        </DataList.Item>
                                    ))}
                                </DataList.Root>
                            </Box>
                        ) : (
                            <Box
                                borderRadius="md"
                                border="1px solid"
                                borderColor="border.divider"
                                p={3}
                                textAlign="center"
                                color="gray.500"
                            >
                                {connectionStatus === 'connecting' ? 'Connecting to WebSocket...' : 'No frag data received'}
                            </Box>
                        )}
                    </VStack>

                    <Flex justifyContent="center">
                        <Link
                            href={ route({ pathname: '/frags' }) }
                            textStyle="sm"
                            style={{ cursor: 'pointer' }}
                        >
                            View all fragments
                        </Link>
                    </Flex>
                </Box>
            </Box>
        </>
    );
};

export default NextBlockFrags;